export default "__VITE_ASSET__DX$Buwu2__"